import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { Helmet } from "react-helmet";
import useScrollTop from '../../hooks/useScrollTop';
import { useLocation } from 'react-router-dom';

function FacebookDeletion(props) {
  useScrollTop(props);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const confirmationId = searchParams.get('id');
  
  return (
    <Fragment>
      <div className="bg-gray-200 min-h-screen">
        <Helmet>
          <title>Facebook Deletion Confirmation - Tunespeak</title>
        </Helmet>
        <Navbar className="bg-blue-gradient text-white" />
        <div className="flex flex-col justify-center items-center my-20">
          {confirmationId ? (
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
              <h2 className="text-2xl font-bold text-green-600 mb-4">Success!</h2>
              <p className="text-gray-700 mb-4">Your Facebook data has been deleted.</p>
            </div>
          ) : (
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
              <h2 className="text-2xl font-bold text-red-600 mb-4">Error</h2>
              <p className="text-gray-700">We were unable to process your request. Please try again.</p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </Fragment>
  )
}

export default FacebookDeletion;
